import { IAppState } from '../../redux';
import { selectUserMoneySource, selectIsSubagent } from '../user';
import { selectPlacingMoneySource } from '../publishTerms';
import { EMoneySource } from '../../redux/reducers';

export const selectCanFillBalance = (state: IAppState): boolean => {
  const isSubagent = selectIsSubagent(state);
  const userMoneySource = selectUserMoneySource(state);
  const placingMoneySource = selectPlacingMoneySource(state);

  return !isSubagent || (userMoneySource === EMoneySource.Self && userMoneySource === placingMoneySource);
};
